import { useState, useEffect } from 'react';
import Api from '../api/api';
import StringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import Loader from '../shared/loader';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Pagination from '../shared/pagination';
import { durationBetweenString, isDateTimeElapsed, toDateTimeString } from '../../utilities/dateUtilities';
import { renderValidity } from '../../utilities/allowListUtilities';

export default function AllowedVrms(props) {

    const [isLoading, setIsLoading] = useState(false);
    const [allowedVrms, setAllowedVrms] = useState(null);
    const [similarityThreshold, setSimilarityThreshold] = useState(65);
    const [pageNumber, setPageNumber] = useState(0);

    const getAllowedVrms = function (page) {
        setIsLoading(true);
        if (!StringHelpers.isNullOrEmpty(props.vrm)) {
            Api.searchAllowedVrms(
                (data) => {
                    setAllowedVrms(data);
                    setIsLoading(false);
                },
                (error) => {
                    console.log(error);
                    setIsLoading(false)
                },
                1,
                page,
                "",
                props.vrm,
                null,
                null,
                similarityThreshold / 100,
                props.siteId,
                0,
                null,
                0,
                null,
                null,
                null,
                false,
                null,
                props.organisationId,
                props.token,
                true
            )
        }
    };

    const onSimilarityThresholdChanged = function () {
        setTimeout(() => {
            getAllowedVrms(0);
        }, 250);
    };

    useEffect(() => {
        getAllowedVrms(0);
    }, []);

    const changePageNumber = function (num) {
        setPageNumber(num);
        getAllowedVrms(num)
    };

    return <div className="card mb-3">
        <div className="card-header">
            <div className="row align-items-center">
                <div className="col">
                    <div className="d-flex justify-content-between">
                        <h5 className="mb-0">
                            <button className="button-no-style button-card-header collapsed" id="ringgo-payments" type="button" data-toggle="collapse" data-target="#ringgo-payments-list" aria-expanded="true" aria-controls="ringgo-payments-list">
                                Allowed List&nbsp;
                                {isLoading &&
                                    <Loader />
                                }
                                {!isLoading &&
                                    <>
                                        {allowedVrms && !arrayUtilities.isNullOrEmpty(allowedVrms.items) &&
                                            <span className={"translate-middle badge rounded-pill " + (allowedVrms.totalCount > 0 ? "bg-success" : "bg-danger")}>
                                                <>{allowedVrms.totalCount}</>
                                            </span>
                                        }
                                        &nbsp;<i className="fas fa-chevron-down"></i>
                                    </>
                                }
                            </button>
                        </h5>

                        <div className='d-flex justify-content-between'>
                            <div className='d-flex align-items-center mr-3'>
                                <label className='m-0 mr-3'>Similarity: {similarityThreshold}%</label>
                                <input class="form-range" type="range" min="0" max="100" value={similarityThreshold} onTouchEnd={onSimilarityThresholdChanged} onMouseUp={onSimilarityThresholdChanged} onChange={(e) => setSimilarityThreshold(Number(e.target.value))} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="card-body bg-light border-top details-container p-0 collapse" id="ringgo-payments-list" aria-labelledby="Allow List" data-parent="#ringgo-payments">
            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                <thead className="bg-200 text-900">
                    <tr>
                        <th>VRM</th>
                        <th>Similarity</th>
                        <th>&nbsp;</th>
                        <th>Driver Name</th>
                        <th>Vehicle Make</th>
                        <th>Vehicle Model</th>
                        <th>Site</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Duration</th>
                        <th>Created Date</th>
                        <th>Created By</th>
                        <th>Validity</th>
                        <th className='text-center'>Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    {allowedVrms && !arrayUtilities.isNullOrEmpty(allowedVrms.items) && allowedVrms.items.map((item) => {
                        var url = "/organisation/" + props.organisationId + "/allowed-vrm/" + item.id;
                        let similarityPercent = (item.similarity * 100).toFixed(0);
                        let similarityClass = item.similarity > 0.99 ? "bg-success" : (item.similarity > 0.6 ? "bg-warning" : "bg-danger");
     
                        return (
                            <tr>
                                <td><Link to={url} className="number-plate-link"><h6 className="mb-0 small-number-plate" >{item.vrm}</h6></Link></td>
                                <td>
                                <div class="progress" style={{minWidth: "100px"}}>
                                    <div class={`progress-bar text-left pl-1 ${similarityClass}`} role="progressbar" style={{width: `${similarityPercent}%`}} aria-valuenow={similarityPercent} aria-valuemin="0" aria-valuemax="100">{similarityPercent}%</div>
                                </div>
                                </td>
                                <td className="text-center">{
                                    !StringHelpers.isNullOrEmpty(item.blueBadgeNumber) && <img width="20px" src='/assets/img/illustrations/wheelchair-symbol.svg' />
                                }</td>
                                <td>{ item.driverName }</td>
                                <td>{item.vehicleMake}</td>
                                <td>{item.vehicleModel}</td>
                                <td>{!StringHelpers.isNullOrEmpty(item.siteId) ? item.siteName : !StringHelpers.isNullOrEmpty(item.clientId) ? item.clientName : <>All</> }</td>
                                <td>
                                    {
                                        !StringHelpers.isNullOrEmpty(item.startDate) 
                                        ? <>{toDateTimeString(item.startDate)} </> 
                                        : <span>&mdash; </span>
                                    }
                                </td>
                                <td>
                                    {
                                        !StringHelpers.isNullOrEmpty(item.endDate) 
                                        ? <>{toDateTimeString(item.endDate)} <span className='text-end'>{isDateTimeElapsed(item.endDate) && <i class="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i>}</span></> 
                                        : <span>&mdash; </span>
                                    }
                                </td>
                                <td>{durationBetweenString(item.startDate, item.endDate)}</td>
                                <td>{!StringHelpers.isNullOrEmpty(item.createdTimestamp) && toDateTimeString(item.createdTimestamp)}</td>
                                <td>{item.createdByUserName}</td>
                                <td>{renderValidity(item)}</td>
                                <td className='text-center'>{item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            <div className="card-footer border-top ">
                <div className="d-flex justify-content-center row align-items-center">
                    <div className="col-auto align-items-center">
                        <Pagination totalResults={allowedVrms?.totalCount} currentPage={pageNumber} changePageNumber={changePageNumber} />
                    </div>
                </div>
            </div>
        </div>
    </div>;
}